import _extends from "@babel/runtime/helpers/esm/extends";
import cx from 'clsx';
import React from 'react';
import { childrenUtils, customPropTypes, getElementType, getUnhandledProps } from '../../lib';
/**
 * A placeholder segment can be inline.
 */

function SegmentInline(props) {
  var children = props.children,
    className = props.className,
    content = props.content;
  var classes = cx('inline', className);
  var rest = getUnhandledProps(SegmentInline, props);
  var ElementType = getElementType(SegmentInline, props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes
  }), childrenUtils.isNil(children) ? content : children);
}
SegmentInline.handledProps = ["as", "children", "className", "content"];
export default SegmentInline;